import { PlusOutlined } from '@ant-design/icons'
import { useTextEditorLocalizable } from '@contexts/TextEditorLocalizableContext'
import { useCurrentEditor } from '@tiptap/react'
import { Button, Dropdown, Flex, MenuProps, Typography } from 'antd'

const { Text } = Typography

export enum TextEditorVariable {
  FIRST_NAME = '%FIRST_NAME%',
  LAST_NAME = '%LAST_NAME%',
  EMAIL = '%EMAIL%',

  // General
  VENUE_NAME = '%VENUE_NAME%',

  // GDPR
  RETENTION_URL = '%RETENTION_URL%',

  // Membership
  PLAN_NAME = '%PLAN_NAME%',
  PLAN_PRICE = '%PLAN_PRICE%',
  FULL_NAME = '%FULL_NAME%',
  RENEWAL_DATE = '%RENEWAL_DATE%',
  SUBSCRIPTION_MANAGE_LINK = '%SUBSCRIPTION_MANAGE_LINK%',
  CODE = '%CODE%',
  REASON = '%REASON%',
}

const MAIL_VARIABLE_LABELS: Record<TextEditorVariable, string> = {
  [TextEditorVariable.FIRST_NAME]: 'First name',
  [TextEditorVariable.LAST_NAME]: 'Last name',
  [TextEditorVariable.EMAIL]: 'Email',
  [TextEditorVariable.VENUE_NAME]: 'Venue name',
  [TextEditorVariable.RETENTION_URL]: 'Retention URL',
  [TextEditorVariable.PLAN_NAME]: 'Plan name',
  [TextEditorVariable.PLAN_PRICE]: 'Plan price',
  [TextEditorVariable.FULL_NAME]: 'Full name',
  [TextEditorVariable.RENEWAL_DATE]: 'Renewal date',
  [TextEditorVariable.SUBSCRIPTION_MANAGE_LINK]: 'Subscription manage link',
  [TextEditorVariable.CODE]: 'Code',
  [TextEditorVariable.REASON]: 'Reason',
}

export const VariablesDropdown = () => {
  const { editor } = useCurrentEditor()
  const { variables } = useTextEditorLocalizable()

  if (!editor || !variables || variables.length === 0) return null
  const items: MenuProps['items'] = variables.map((variable, index) => ({
    key: index,
    label: (
      <Flex vertical gap={1}>
        <Text>{MAIL_VARIABLE_LABELS[variable]}</Text>
        <Text type="secondary">{variable}</Text>
      </Flex>
    ),
    onClick: () => {
      editor.chain().focus().insertContent(variable).run()
    },
  }))

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Button
        variant="filled"
        color="default"
        size="small"
        icon={<PlusOutlined />}
      >
        Insert variable
      </Button>
    </Dropdown>
  )
}
